/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiLeadScraperMicroserviceApiV1WebhooksRequest = {
  organizationId?: string | undefined;
  workspaceId?: string | undefined;
  tenantId?: string | undefined;
  accountId?: string | undefined;
  pageSize?: number | undefined;
  pageNumber?: number | undefined;
  status?: string | undefined;
  search?: string | undefined;
};

export const GetApiLeadScraperMicroserviceApiV1WebhooksTriggerEvents = {
  TriggerEventUnspecified: "TRIGGER_EVENT_UNSPECIFIED",
  TriggerEventJobStarted: "TRIGGER_EVENT_JOB_STARTED",
  TriggerEventJobCompleted: "TRIGGER_EVENT_JOB_COMPLETED",
  TriggerEventJobFailed: "TRIGGER_EVENT_JOB_FAILED",
  TriggerEventLeadFound: "TRIGGER_EVENT_LEAD_FOUND",
  TriggerEventQuotaExceeded: "TRIGGER_EVENT_QUOTA_EXCEEDED",
  TriggerEventErrorThresholdReached: "TRIGGER_EVENT_ERROR_THRESHOLD_REACHED",
  TriggerEventRateLimitReached: "TRIGGER_EVENT_RATE_LIMIT_REACHED",
  TriggerEventDataValidationFailed: "TRIGGER_EVENT_DATA_VALIDATION_FAILED",
  TriggerEventNewProxyNeeded: "TRIGGER_EVENT_NEW_PROXY_NEEDED",
  TriggerEventScheduledMaintenance: "TRIGGER_EVENT_SCHEDULED_MAINTENANCE",
} as const;
export type GetApiLeadScraperMicroserviceApiV1WebhooksTriggerEvents =
  ClosedEnum<typeof GetApiLeadScraperMicroserviceApiV1WebhooksTriggerEvents>;

export const GetApiLeadScraperMicroserviceApiV1WebhooksIncludedFields = {
  IncludedFieldUnspecified: "INCLUDED_FIELD_UNSPECIFIED",
  IncludedFieldName: "INCLUDED_FIELD_NAME",
  IncludedFieldWebsite: "INCLUDED_FIELD_WEBSITE",
  IncludedFieldPhone: "INCLUDED_FIELD_PHONE",
  IncludedFieldAddress: "INCLUDED_FIELD_ADDRESS",
  IncludedFieldLocation: "INCLUDED_FIELD_LOCATION",
  IncludedFieldCoordinates: "INCLUDED_FIELD_COORDINATES",
  IncludedFieldGoogleRating: "INCLUDED_FIELD_GOOGLE_RATING",
  IncludedFieldReviewCount: "INCLUDED_FIELD_REVIEW_COUNT",
  IncludedFieldReviews: "INCLUDED_FIELD_REVIEWS",
  IncludedFieldBusinessHours: "INCLUDED_FIELD_BUSINESS_HOURS",
  IncludedFieldBusinessStatus: "INCLUDED_FIELD_BUSINESS_STATUS",
  IncludedFieldPlaceId: "INCLUDED_FIELD_PLACE_ID",
  IncludedFieldGoogleMapsUrl: "INCLUDED_FIELD_GOOGLE_MAPS_URL",
  IncludedFieldPhotos: "INCLUDED_FIELD_PHOTOS",
  IncludedFieldMainPhoto: "INCLUDED_FIELD_MAIN_PHOTO",
  IncludedFieldBusinessTypes: "INCLUDED_FIELD_BUSINESS_TYPES",
  IncludedFieldAmenities: "INCLUDED_FIELD_AMENITIES",
  IncludedFieldPaymentMethods: "INCLUDED_FIELD_PAYMENT_METHODS",
  IncludedFieldSocialProfiles: "INCLUDED_FIELD_SOCIAL_PROFILES",
  IncludedFieldEmployeeCount: "INCLUDED_FIELD_EMPLOYEE_COUNT",
  IncludedFieldRevenueInfo: "INCLUDED_FIELD_REVENUE_INFO",
  IncludedFieldFoundedYear: "INCLUDED_FIELD_FOUNDED_YEAR",
  IncludedFieldCertifications: "INCLUDED_FIELD_CERTIFICATIONS",
  IncludedFieldNaicsCode: "INCLUDED_FIELD_NAICS_CODE",
  IncludedFieldSicCode: "INCLUDED_FIELD_SIC_CODE",
  IncludedFieldScrapingMetadata: "INCLUDED_FIELD_SCRAPING_METADATA",
  IncludedFieldComplianceInfo: "INCLUDED_FIELD_COMPLIANCE_INFO",
  IncludedFieldAlternatePhones: "INCLUDED_FIELD_ALTERNATE_PHONES",
  IncludedFieldContactPerson: "INCLUDED_FIELD_CONTACT_PERSON",
  IncludedFieldContactEmail: "INCLUDED_FIELD_CONTACT_EMAIL",
} as const;
export type GetApiLeadScraperMicroserviceApiV1WebhooksIncludedFields =
  ClosedEnum<typeof GetApiLeadScraperMicroserviceApiV1WebhooksIncludedFields>;

export const GetApiLeadScraperMicroserviceApiV1WebhooksPayloadFormat = {
  PayloadFormatUnspecified: "PAYLOAD_FORMAT_UNSPECIFIED",
  PayloadFormatJson: "PAYLOAD_FORMAT_JSON",
  PayloadFormatXml: "PAYLOAD_FORMAT_XML",
  PayloadFormatFormData: "PAYLOAD_FORMAT_FORM_DATA",
  PayloadFormatProtobuf: "PAYLOAD_FORMAT_PROTOBUF",
  PayloadFormatYaml: "PAYLOAD_FORMAT_YAML",
} as const;
export type GetApiLeadScraperMicroserviceApiV1WebhooksPayloadFormat =
  ClosedEnum<typeof GetApiLeadScraperMicroserviceApiV1WebhooksPayloadFormat>;

export type GetApiLeadScraperMicroserviceApiV1WebhooksMetadata = {};

export type GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks = {
  id?: string | undefined;
  url?: string | undefined;
  authType?: string | undefined;
  authToken?: string | undefined;
  customHeaders?: { [k: string]: string } | undefined;
  maxRetries?: number | undefined;
  retryInterval?: string | undefined;
  triggerEvents?:
    | Array<GetApiLeadScraperMicroserviceApiV1WebhooksTriggerEvents>
    | undefined;
  includedFields?:
    | Array<GetApiLeadScraperMicroserviceApiV1WebhooksIncludedFields>
    | undefined;
  includeFullResults?: boolean | undefined;
  payloadFormat?:
    | GetApiLeadScraperMicroserviceApiV1WebhooksPayloadFormat
    | undefined;
  verifySsl?: boolean | undefined;
  signingSecret?: string | undefined;
  rateLimit?: number | undefined;
  rateLimitInterval?: string | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  lastTriggeredAt?: Date | undefined;
  successfulCalls?: number | undefined;
  failedCalls?: number | undefined;
  metadata?: GetApiLeadScraperMicroserviceApiV1WebhooksMetadata | undefined;
  webhookName?: string | undefined;
};

export type GetApiLeadScraperMicroserviceApiV1WebhooksData = {
  webhooks?:
    | Array<GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks>
    | undefined;
  nextPageNumber?: number | undefined;
  totalCount?: number | undefined;
};

/**
 * Lists all webhook configurations with pagination
 */
export type GetApiLeadScraperMicroserviceApiV1WebhooksResponseBody = {
  data: GetApiLeadScraperMicroserviceApiV1WebhooksData;
};

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WebhooksRequest$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WebhooksRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    organizationId: z.string().optional(),
    workspaceId: z.string().optional(),
    tenantId: z.string().optional(),
    accountId: z.string().optional(),
    pageSize: z.number().optional(),
    pageNumber: z.number().optional(),
    status: z.string().optional(),
    search: z.string().optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1WebhooksRequest$Outbound = {
  organizationId?: string | undefined;
  workspaceId?: string | undefined;
  tenantId?: string | undefined;
  accountId?: string | undefined;
  pageSize?: number | undefined;
  pageNumber?: number | undefined;
  status?: string | undefined;
  search?: string | undefined;
};

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WebhooksRequest$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WebhooksRequest$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1WebhooksRequest
  > = z.object({
    organizationId: z.string().optional(),
    workspaceId: z.string().optional(),
    tenantId: z.string().optional(),
    accountId: z.string().optional(),
    pageSize: z.number().optional(),
    pageNumber: z.number().optional(),
    status: z.string().optional(),
    search: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WebhooksRequest$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WebhooksRequest$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WebhooksRequest$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksRequest$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1WebhooksRequest$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1WebhooksRequestToJSON(
  getApiLeadScraperMicroserviceApiV1WebhooksRequest:
    GetApiLeadScraperMicroserviceApiV1WebhooksRequest,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1WebhooksRequest$outboundSchema.parse(
      getApiLeadScraperMicroserviceApiV1WebhooksRequest,
    ),
  );
}

export function getApiLeadScraperMicroserviceApiV1WebhooksRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1WebhooksRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1WebhooksRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1WebhooksRequest' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WebhooksTriggerEvents$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WebhooksTriggerEvents
  > = z.nativeEnum(GetApiLeadScraperMicroserviceApiV1WebhooksTriggerEvents);

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WebhooksTriggerEvents$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WebhooksTriggerEvents
  > = GetApiLeadScraperMicroserviceApiV1WebhooksTriggerEvents$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WebhooksTriggerEvents$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksTriggerEvents$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WebhooksTriggerEvents$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksTriggerEvents$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WebhooksTriggerEvents$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WebhooksIncludedFields$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WebhooksIncludedFields
  > = z.nativeEnum(GetApiLeadScraperMicroserviceApiV1WebhooksIncludedFields);

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WebhooksIncludedFields$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WebhooksIncludedFields
  > = GetApiLeadScraperMicroserviceApiV1WebhooksIncludedFields$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WebhooksIncludedFields$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksIncludedFields$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WebhooksIncludedFields$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksIncludedFields$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WebhooksIncludedFields$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WebhooksPayloadFormat$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WebhooksPayloadFormat
  > = z.nativeEnum(GetApiLeadScraperMicroserviceApiV1WebhooksPayloadFormat);

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WebhooksPayloadFormat$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WebhooksPayloadFormat
  > = GetApiLeadScraperMicroserviceApiV1WebhooksPayloadFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WebhooksPayloadFormat$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksPayloadFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WebhooksPayloadFormat$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksPayloadFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WebhooksPayloadFormat$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WebhooksMetadata$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WebhooksMetadata,
    z.ZodTypeDef,
    unknown
  > = z.object({});

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1WebhooksMetadata$Outbound = {};

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WebhooksMetadata$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WebhooksMetadata$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1WebhooksMetadata
  > = z.object({});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WebhooksMetadata$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksMetadata$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WebhooksMetadata$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksMetadata$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WebhooksMetadata$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksMetadata$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1WebhooksMetadata$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1WebhooksMetadataToJSON(
  getApiLeadScraperMicroserviceApiV1WebhooksMetadata:
    GetApiLeadScraperMicroserviceApiV1WebhooksMetadata,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1WebhooksMetadata$outboundSchema.parse(
      getApiLeadScraperMicroserviceApiV1WebhooksMetadata,
    ),
  );
}

export function getApiLeadScraperMicroserviceApiV1WebhooksMetadataFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1WebhooksMetadata,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1WebhooksMetadata$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1WebhooksMetadata' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    url: z.string().optional(),
    authType: z.string().optional(),
    authToken: z.string().optional(),
    customHeaders: z.record(z.string()).optional(),
    maxRetries: z.number().int().optional(),
    retryInterval: z.string().optional(),
    triggerEvents: z.array(
      GetApiLeadScraperMicroserviceApiV1WebhooksTriggerEvents$inboundSchema,
    ).optional(),
    includedFields: z.array(
      GetApiLeadScraperMicroserviceApiV1WebhooksIncludedFields$inboundSchema,
    ).optional(),
    includeFullResults: z.boolean().optional(),
    payloadFormat:
      GetApiLeadScraperMicroserviceApiV1WebhooksPayloadFormat$inboundSchema
        .default("PAYLOAD_FORMAT_UNSPECIFIED"),
    verifySsl: z.boolean().optional(),
    signingSecret: z.string().optional(),
    rateLimit: z.number().int().optional(),
    rateLimitInterval: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    lastTriggeredAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    successfulCalls: z.number().int().optional(),
    failedCalls: z.number().int().optional(),
    metadata: z.lazy(() =>
      GetApiLeadScraperMicroserviceApiV1WebhooksMetadata$inboundSchema
    ).optional(),
    webhookName: z.string().optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks$Outbound = {
  id?: string | undefined;
  url?: string | undefined;
  authType?: string | undefined;
  authToken?: string | undefined;
  customHeaders?: { [k: string]: string } | undefined;
  maxRetries?: number | undefined;
  retryInterval?: string | undefined;
  triggerEvents?: Array<string> | undefined;
  includedFields?: Array<string> | undefined;
  includeFullResults?: boolean | undefined;
  payloadFormat: string;
  verifySsl?: boolean | undefined;
  signingSecret?: string | undefined;
  rateLimit?: number | undefined;
  rateLimitInterval?: string | undefined;
  createdAt?: string | undefined;
  updatedAt?: string | undefined;
  lastTriggeredAt?: string | undefined;
  successfulCalls?: number | undefined;
  failedCalls?: number | undefined;
  metadata?:
    | GetApiLeadScraperMicroserviceApiV1WebhooksMetadata$Outbound
    | undefined;
  webhookName?: string | undefined;
};

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks
  > = z.object({
    id: z.string().optional(),
    url: z.string().optional(),
    authType: z.string().optional(),
    authToken: z.string().optional(),
    customHeaders: z.record(z.string()).optional(),
    maxRetries: z.number().int().optional(),
    retryInterval: z.string().optional(),
    triggerEvents: z.array(
      GetApiLeadScraperMicroserviceApiV1WebhooksTriggerEvents$outboundSchema,
    ).optional(),
    includedFields: z.array(
      GetApiLeadScraperMicroserviceApiV1WebhooksIncludedFields$outboundSchema,
    ).optional(),
    includeFullResults: z.boolean().optional(),
    payloadFormat:
      GetApiLeadScraperMicroserviceApiV1WebhooksPayloadFormat$outboundSchema
        .default("PAYLOAD_FORMAT_UNSPECIFIED"),
    verifySsl: z.boolean().optional(),
    signingSecret: z.string().optional(),
    rateLimit: z.number().int().optional(),
    rateLimitInterval: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    lastTriggeredAt: z.date().transform(v => v.toISOString()).optional(),
    successfulCalls: z.number().int().optional(),
    failedCalls: z.number().int().optional(),
    metadata: z.lazy(() =>
      GetApiLeadScraperMicroserviceApiV1WebhooksMetadata$outboundSchema
    ).optional(),
    webhookName: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1WebhooksWebhooksToJSON(
  getApiLeadScraperMicroserviceApiV1WebhooksWebhooks:
    GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks$outboundSchema.parse(
      getApiLeadScraperMicroserviceApiV1WebhooksWebhooks,
    ),
  );
}

export function getApiLeadScraperMicroserviceApiV1WebhooksWebhooksFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WebhooksData$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WebhooksData,
    z.ZodTypeDef,
    unknown
  > = z.object({
    webhooks: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks$inboundSchema
      ),
    ).optional(),
    nextPageNumber: z.number().int().optional(),
    totalCount: z.number().int().optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1WebhooksData$Outbound = {
  webhooks?:
    | Array<GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks$Outbound>
    | undefined;
  nextPageNumber?: number | undefined;
  totalCount?: number | undefined;
};

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WebhooksData$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WebhooksData$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1WebhooksData
  > = z.object({
    webhooks: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1WebhooksWebhooks$outboundSchema
      ),
    ).optional(),
    nextPageNumber: z.number().int().optional(),
    totalCount: z.number().int().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WebhooksData$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksData$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WebhooksData$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksData$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WebhooksData$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksData$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1WebhooksData$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1WebhooksDataToJSON(
  getApiLeadScraperMicroserviceApiV1WebhooksData:
    GetApiLeadScraperMicroserviceApiV1WebhooksData,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1WebhooksData$outboundSchema.parse(
      getApiLeadScraperMicroserviceApiV1WebhooksData,
    ),
  );
}

export function getApiLeadScraperMicroserviceApiV1WebhooksDataFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1WebhooksData,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1WebhooksData$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1WebhooksData' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WebhooksResponseBody$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WebhooksResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    data: z.lazy(() =>
      GetApiLeadScraperMicroserviceApiV1WebhooksData$inboundSchema
    ),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1WebhooksResponseBody$Outbound = {
  data: GetApiLeadScraperMicroserviceApiV1WebhooksData$Outbound;
};

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WebhooksResponseBody$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WebhooksResponseBody$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1WebhooksResponseBody
  > = z.object({
    data: z.lazy(() =>
      GetApiLeadScraperMicroserviceApiV1WebhooksData$outboundSchema
    ),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WebhooksResponseBody$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksResponseBody$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WebhooksResponseBody$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksResponseBody$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WebhooksResponseBody$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksResponseBody$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1WebhooksResponseBody$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1WebhooksResponseBodyToJSON(
  getApiLeadScraperMicroserviceApiV1WebhooksResponseBody:
    GetApiLeadScraperMicroserviceApiV1WebhooksResponseBody,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1WebhooksResponseBody$outboundSchema.parse(
      getApiLeadScraperMicroserviceApiV1WebhooksResponseBody,
    ),
  );
}

export function getApiLeadScraperMicroserviceApiV1WebhooksResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1WebhooksResponseBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1WebhooksResponseBody$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1WebhooksResponseBody' from JSON`,
  );
}
